import React, { useEffect, useState } from 'react';
import ProgressBar from 'components/ProgressBar';
import Tooltip from 'components/Tooltip';
import { DeviceRestrictions } from 'types/InputInfo';
import { useTranslation } from 'react-i18next';
import 'assets/css/components/Input.scss';

type InputProps = {
  title: string,
  restrictions: DeviceRestrictions,
  value: string,
  onChange: (value: string) => void,
  tooltip: {
    title: string,
    description: string
  },
  isTextArea?: boolean
};

const Input = ({ title, restrictions, value, onChange, tooltip, isTextArea = false }: InputProps): JSX.Element => {
  const { t } = useTranslation();
  const inputId = React.useId();
  const counterId = React.useId();
  const [pixels, setPixels] = useState<number>(0);

  const onInputChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.currentTarget.value);
  };

  useEffect(() => {
    if (value.length !== 0) {
      const container = window.document.getElementById(`hidden_result_${title}`);
      setPixels(container?.offsetWidth || 0);
    } else {
      setPixels(0);
    }
  }, [value])

  return (
    <div className='input-holder'>

      <div className='input-holder-top'>
        <label htmlFor={ inputId } className='input-holder-top__label'>
          <span>{ title }</span>
        </label>
        <div id={ counterId } className='input-holder-top__counter'>
          { pixels }/{ restrictions.maxPixels } { t('form_pixels') }, { value.length } { t('form_characters') }
        </div>
      </div>

      <div className='input-holder-main'>
        <div className='input-holder-main__element'>
          { isTextArea
            ? <textarea id={ inputId } name={ inputId } value={ value } onChange={ onInputChange } aria-describedby={ counterId } />
            : <input type="text" id={ inputId } name={ inputId } value={ value } onChange={ onInputChange } aria-describedby={ counterId } />
          }
        </div>
        <ProgressBar
          pixels={ pixels }
          maxPixels={ restrictions.maxPixels }
          minSuccessPixels={ restrictions.minSuccess }
          maxSuccessPixels={ restrictions.maxSuccess }
        />
      </div>

      <div className='input-holder-bottom'>
        <Tooltip
          item={ title }
          title={ tooltip.title }
          content={ tooltip.description }
        />
      </div>
    </div>
  );
}

export default Input;
